import { RequestStatus } from '../../utils';

export interface ChatState {
  status: RequestStatus;
}

export const initialState: ChatState = {
  status: 'idle',
};
